import { render, staticRenderFns } from "./authUser.vue?vue&type=template&id=54202984&scoped=true"
import script from "./authUser.vue?vue&type=script&lang=js"
export * from "./authUser.vue?vue&type=script&lang=js"
import style0 from "./authUser.vue?vue&type=style&index=0&id=54202984&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54202984",
  null
  
)

export default component.exports